import { render } from "./AdminBills.vue?vue&type=template&id=51a25e9d&scoped=true"
import script from "./AdminBills.vue?vue&type=script&lang=js"
export * from "./AdminBills.vue?vue&type=script&lang=js"

import "./AdminBills.vue?vue&type=style&index=0&id=51a25e9d&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\ssradius\\frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51a25e9d"]])

export default __exports__